import { defineMessages } from "react-intl";

const messages = defineMessages({
  addNote: {
    id: "activity.activityNote.addNote",
    defaultMessage: "Add Note",
    description: "message for add note button",
  },
  alert: {
    id: "activity.activityNote.notAllMentionedUsersHaveAccessToActivity",
    defaultMessage:
      "The user(s) you have tagged below will not be notified because they do not have access to one of the related records (Company, Person, or Deal) and/or the activity’s visibility has been marked as private.",
    description: "Activity note - not all mentioned users have access to activity",
  },
  cancel: {
    id: "activity.activityNote.cancel",
    defaultMessage: "Cancel",
    description: "message for cancel button",
  },
  delete: {
    id: "activity.activityNote.deleteNote",
    defaultMessage: "Delete Note",
    description: "message for delete note button",
  },
  deleteConfirm: {
    id: "activity.activityNote.deleteNote.confirm.title",
    defaultMessage: "Delete note?",
    description: "message for delete note confirm modal",
  },
  edit: {
    id: "activity.activityNote.editNote",
    defaultMessage: "Edit Note",
    description: "message for edit note button",
  },
  leaveConfirm: {
    id: "activity.activityNote.edit.leaveConfirm",
    defaultMessage: "Leave without saving changes?",
    description: "message for leave note confirm modal",
  },
  no: {
    id: "activity.activityNote.no",
    defaultMessage: "No",
    description: "message for No button",
  },
  note: {
    id: "activity.activityNote.note",
    defaultMessage: "Note",
    description: "message for note component label",
  },
  placeholder: {
    id: "activity.activityNote.placeholder",
    defaultMessage: "Add note",
    description: "Note field placeholder for activity",
  },
  save: {
    id: "activity.activityNote.save",
    defaultMessage: "Save",
    description: "message for save note button",
  },
  viewNote: {
    id: "activity.activityNote.viewNote",
    defaultMessage: "View Note",
    description: "message for view note button",
  },
  yes: {
    id: "activity.activityNote.yes",
    defaultMessage: "Yes",
    description: "message for Yes button",
  },
});

export default messages;
